import { Hero } from "@/sections/Hero";
import { Marquee } from "@/components/Marquee";
import { Heritage } from "@/sections/Heritage";
import { ProductsBento } from "@/sections/ProductsBento";
import { Capabilities } from "@/sections/Capabilities";
import { GalleryStrip } from "@/sections/GalleryStrip";
import { Logistics } from "@/sections/Logistics";
import { CtaBand } from "@/sections/CtaBand";
import { Seo } from "@/components/Seo";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="Sebastian's Produce Inc. — Wholesale Fresh Produce, Los Angeles"
        description="Family-run wholesale fresh produce supplier in Los Angeles since 1968. Colored bell peppers, Mexican chilies, tomatoes, squash, cucumbers, salads and fruit for food manufacturers and restaurants."
      />
      <Hero />
      <Marquee />
      <Heritage />
      <ProductsBento />
      <Capabilities />
      <GalleryStrip />
      <Logistics />
      <CtaBand />
    </main>
  );
}
